module.exports = __webpack_public_path__ + "img/fast@2x.e51cc49c.png";